import {
  queryOptions,
  useMutation,
  useQuery,
  useQueryClient,
} from '@tanstack/react-query';

import { getJwt, removeJwt, setJwt } from '@jane/shared/auth';

export const getJwtQueryOptions = () =>
  queryOptions({
    queryFn: () => getJwt(),
    queryKey: ['jwt', getJwt()],
    staleTime: Infinity,
  });

export const useGetJwt = () => useQuery(getJwtQueryOptions());

export const useSaveJwt = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (jwt: string | null) => {
      if (jwt) {
        return setJwt(jwt);
      } else {
        return removeJwt();
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['jwt'] });
    },
  });
};
